/**
 * Thing readings ingress (v2 capture P6) — typed wrapper over
 * `POST /v1/things/{thing_id}/readings`, the data-source ingress for manual /
 * app entry.
 *
 * The data-entry form (routes/iot/data-entry.tsx) and the mobile Quick-Entry
 * sheet publish discrete identifiers (pattern / mould / casting / qc) + numeric
 * equipment-config here; the rows land in the readings hypertable and the
 * capture-worker assembles them into genealogy via the genealogy_role bindings
 * — the same pipeline as a scanned MQTT source.
 *
 * Org-scoped (X-Org-Id attached by the api client). The reading's device_id is
 * the thing's slug server-side, so `device_id` below is advisory only.
 * `data_kind` is inferred server-side from the payload: `value_text` →
 * string_label (the discrete-id rows the capture trigger fires on); `value` →
 * analog_scalar. Send `value_text` for an id/label, `value` for a numeric.
 */

import { api } from "@/lib/api-client";

/** One reading to publish. */
export interface ReadingInput {
  metric: string;
  value?: number;
  value_text?: string;
  ts?: string;
}

export interface PublishReadingsBody {
  /** Advisory only — the server uses the thing's slug as the readings device_id. */
  device_id?: string;
  readings: ReadingInput[];
}

export interface PublishReadingsResult {
  accepted: number;
}

export const thingReadings = {
  publish: (thingId: string, body: PublishReadingsBody) =>
    api.post<PublishReadingsResult>(`/v1/things/${thingId}/readings`, body),
};
